import type { LucideProps } from "lucide-react";

/**
 * Custom "Apps" icon following Lucide design guidelines.
 * https://lucide.dev/guide/design/icon-design-guide
 *
 * Design: Rounded app square with centered Lucide sparkle overlay
 *
 * Specifications:
 * - Canvas: 24x24px
 * - Main square: 1px gap from edges (22x22), rounded rectangle
 * - Sparkle: 75% size Lucide sparkle, centered in icon
 * - Stroke: consistent 2px throughout
 *
 * Made with ♥︎ by Opus 4.5 + Peter
 */
export function AppSparkle({
  size = 24,
  strokeWidth = 2,
  color = "currentColor",
  className,
  ...props
}: LucideProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* Main app square - 1px gap from edges, maximum size */}
      <rect x={1} y={1} width={22} height={22} rx={4} />

      {/* Lucide Sparkle - 75% size, centered at (12, 12), stroke only */}
      {/* Manually scaled path (all values * 0.75, centered in icon) */}
      <path d="M11.26 5.11a0.75 0.75 0 0 1 1.475 0l0.788 4.169a1.5 1.5 0 0 0 1.196 1.196l4.169 0.788a0.75 0.75 0 0 1 0 1.475l-4.169 0.788a1.5 1.5 0 0 0-1.196 1.196l-0.788 4.169a0.75 0.75 0 0 1-1.475 0l-0.788-4.169a1.5 1.5 0 0 0-1.196-1.196l-4.169-0.788a0.75 0.75 0 0 1 0-1.475l4.169-0.788a1.5 1.5 0 0 0 1.196-1.196z" />
    </svg>
  );
}
